import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const LegalLicense = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-white mb-2">Licencia de Uso</h1>
          <p className="text-cyan-400 mb-8">Creative Commons Atribución – No Comercial – Compartir Igual 4.0 Internacional (CC BY-NC-SA 4.0)</p>
          
          <div className="prose prose-invert prose-slate max-w-none">
            <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-8 space-y-8 text-slate-300">
              
              <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4">
                <p className="text-white font-semibold mb-2">BLOX — Lenguaje de Programación Educativo en Español</p>
                <p className="text-slate-400 text-sm">Copyright (c) 2025 - Autor: Carlos J. Melgarejo</p>
              </div>

              <p>
                Este proyecto, incluyendo su intérprete, librerías básicas gratuitas,
                documentación inicial y ejemplos asociados, se distribuye bajo la licencia
                Creative Commons BY-NC-SA 4.0. Al utilizar BLOX, usted acepta los términos
                y condiciones detallados a continuación.
              </p>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                  <span className="text-green-400">✓</span> Permisos Concedidos
                </h2>
                <p className="mb-4">De acuerdo con los términos de la licencia CC BY-NC-SA 4.0, usted tiene derecho a:</p>
                <ul className="list-none space-y-3">
                  <li className="flex gap-3">
                    <span className="text-green-400 font-bold">1.</span>
                    <span><strong className="text-white">USAR</strong> el software y la documentación con fines personales, educativos, académicos o de investigación.</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="text-green-400 font-bold">2.</span>
                    <span><strong className="text-white">COPIAR y REDISTRIBUIR</strong> el material en cualquier medio o formato, siempre y cuando se incluya la atribución correspondiente.</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="text-green-400 font-bold">3.</span>
                    <span><strong className="text-white">ADAPTAR, MODIFICAR o CREAR</strong> obras derivadas del material, bajo la condición de que dichas obras se distribuyan bajo la misma licencia (CC BY-NC-SA 4.0).</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="text-green-400 font-bold">4.</span>
                    <span><strong className="text-white">UTILIZAR BLOX</strong> en instituciones educativas (escuelas, colegios, universidades), siempre que su uso no tenga carácter comercial.</span>
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                  <span className="text-red-400">✗</span> Restricciones
                </h2>
                <p className="mb-4">Queda estrictamente prohibido:</p>
                <ul className="list-none space-y-3">
                  <li className="flex gap-3">
                    <span className="text-red-400 font-bold">1.</span>
                    <div>
                      <strong className="text-white">UTILIZAR BLOX con fines COMERCIALES</strong> sin autorización expresa del autor. Esto incluye:
                      <ul className="list-disc pl-6 mt-2 text-slate-400 space-y-1">
                        <li>Venta de software basado en BLOX</li>
                        <li>Cursos pagos cuyo contenido dependa de BLOX</li>
                        <li>Licencias institucionales remuneradas</li>
                        <li>Integración en productos o servicios comerciales</li>
                        <li>Distribución de versiones modificadas con fines lucrativos</li>
                      </ul>
                    </div>
                  </li>
                  <li className="flex gap-3">
                    <span className="text-red-400 font-bold">2.</span>
                    <span><strong className="text-white">REDISTRIBUIR o MODIFICAR</strong> las APIs premium, manuales avanzados, documentación profesional, certificados y cursos oficiales, los cuales están sujetos a licencias comerciales diferentes.</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="text-red-400 font-bold">3.</span>
                    <span><strong className="text-white">ELIMINAR o ALTERAR</strong> los avisos de autoría, créditos y propiedad intelectual incluidos en el software y la documentación.</span>
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">📝 Atribución</h2>
                <p className="mb-4">Toda redistribución o uso del material debe incluir la siguiente atribución:</p>
                <div className="bg-slate-800 border border-cyan-500/30 rounded-lg p-4 font-mono text-sm">
                  <p className="text-cyan-300">"Este software utiliza el lenguaje BLOX, desarrollado por</p>
                  <p className="text-cyan-300">Carlos J. Melgarejo — blox.com.py"</p>
                </div>
                <p className="mt-4 text-slate-400">Si se realizan cambios o modificaciones, debe indicarse claramente.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">⚠️ Descargo de Responsabilidad</h2>
                <p className="text-slate-400">
                  BLOX se proporciona "TAL CUAL", sin garantías de ningún tipo, explícitas
                  o implícitas. El autor no será responsable por daños directos, indirectos,
                  incidentales o consecuentes derivados del uso del software.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">📋 Excepciones y Notas</h2>
                <ul className="list-disc pl-6 space-y-2 text-slate-400">
                  <li>Las APIs avanzadas (IA, sockets, scraping, estadísticas, etc.) se distribuyen bajo licencias comerciales independientes y NO forman parte de esta licencia.</li>
                  <li>Los manuales premium, cursos, certificaciones y materiales académicos avanzados poseen restricciones adicionales y no están cubiertos por la licencia pública.</li>
                  <li>El autor se reserva el derecho de ofrecer licencias institucionales, comerciales o personalizadas según corresponda.</li>
                </ul>
              </section>

              <section className="border-t border-slate-700 pt-6">
                <h2 className="text-2xl font-semibold text-white mb-4">🔗 Texto Legal Completo</h2>
                <p className="mb-4">El texto completo de la licencia CC BY-NC-SA 4.0 puede consultarse en:</p>
                <a 
                  href="https://creativecommons.org/licenses/by-nc-sa/4.0/legalcode" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 underline"
                >
                  https://creativecommons.org/licenses/by-nc-sa/4.0/legalcode
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </section>

              <section className="border-t border-slate-700 pt-6">
                <h2 className="text-2xl font-semibold text-white mb-4">📩 Contacto</h2>
                <p>
                  Para consultas sobre licenciamiento comercial o institucional: {' '}
                  <a href="mailto:blox.com.py@gmail.com" className="text-cyan-400 hover:text-cyan-300">
                    blox.com.py@gmail.com
                  </a>
                </p>
              </section>

            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LegalLicense;
